// extracted by mini-css-extract-plugin
export default {"aside":"styles_aside__9cUIZ","asideRightAnimation":"styles_asideRightAnimation__uB1W3"};